/** Key used to store the Firebase auth token in localStorage. */
export const TOKEN_KEY = "ticketin_auth_token";
